import styled from 'styled-components';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { Flex } from '../Flex';

const ActiveIcon = styled(VisibilityIcon)`
  color: #a3a2a9;
`;
const InactiveIcon = styled(VisibilityOffIcon)`
  color: #ed5538;
`;

const VisibilityCellRenderer = (props) => {
  return (
    <Flex justifyContent="center" alignItems="center" height="38px">
      {props.value === 'Active' ? <ActiveIcon /> : <InactiveIcon />}
    </Flex>
  );
};

export default VisibilityCellRenderer;
